import React, { useContext } from 'react';
import useForm from '../Hooks/useForm';
import Input from '../Form/Input';
import styles from './LoginForm.module.css';
import login from '../../Assets/img-login.jpg';
import logomedico from '../../Assets/medicologo.png';
import konecta_marca_vertical_terciaria from '../../Assets/konecta_marca_vertical_terciaria.png';
import konecta_marca_horizontal_positiva from '../../Assets/konecta_marca_horizontal_positiva.png';
import logo_1 from '../../Assets/logo_1.png';
import logo from '../../Assets/logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../UserContext';

const LoginForm = () => {
  const { userLogin, error, loading } = useContext(UserContext);
  const usuario = useForm('cpf');
  const senha = useForm('');
  const navigate = useNavigate();
  const [tamanhoCampo, setTamanhoCampo] = React.useState(100);
  const regex = /^[0-9.-]+$/;

  React.useEffect(() => {
    if (regex.test(usuario.value)) {
      setTamanhoCampo(14);
    } else if (
      usuario.value === '' ||
      usuario.value === undefined ||
      !regex.test(usuario.value)
    ) {
      setTamanhoCampo(100);
    }
  }, [usuario.value]);

  function loginNavigate(e: any) {
    e.preventDefault();
    if (usuario.validate() && senha.validate()) {
      userLogin(usuario.value, senha.value);
    }
  }

  return (
    <section className={styles.login}>
      <div className={styles.ContainerImg}>
        <img
          className={styles.logoimg}
          src={konecta_marca_vertical_terciaria}
          alt="logotipo konecta"
        />
        {/* <div className={styles.fraselogo}>
          <p>
            Conecte-se à sua Saúde em um clique:
            <span className={styles.spanBemestar}>
              Seu <span className={styles.bemestar}>BEM-ESTAR</span> em suas
              mãos!
            </span>
          </p>
        </div> */}
      </div>
      <div className={styles.divLogin}>
        <img
          className={styles.logoForm}
          src={konecta_marca_horizontal_positiva}
          alt="logo konecta"
        />
        <div className={styles.divLogoLogin}>
          <div className={styles.containerLogin}>
            {/* <h1 className={styles.bemVindo}>
              {' '}
              <span className={styles.r}>Konecta</span>
              <span className={styles.x}> Saúde</span>
            </h1> */}
            <form className={styles.form} onSubmit={loginNavigate}>
              <Input
                name="usuario"
                type="text"
                label="Usuário"
                placeholder="Digite seu CPF"
                maxLength={tamanhoCampo}
                {...usuario}
              />
              <Input
                name="senha"
                type="password"
                label="Senha"
                placeholder="********"
                {...senha}
              />
              <div className={styles.esqueceu}>
                <Link className={styles.link} to="/perdeu">
                  Esqueceu sua senha?
                </Link>
              </div>
              <button type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <span className={styles.spinner}></span>
                  </>
                ) : (
                  'Entrar'
                )}
              </button>

              <p className={styles.errorMessage}>{error}</p>
            </form>
            {/* <div className={styles.links}>
      <a href="">Suporte</a>
      <a href="">Contato</a>
      <a href="">Produtos</a>
      </div> */}
          </div>
        </div>
        <Link to={'https://konsist.com.br'} target="_blank">
          <div className={styles.divLogoFrase}>
            <img className={styles.logo} src={logo_1} alt="Logo konsist" />
            <p
              className={styles.linkKonsist}
              // href="https://www.konsist.com.br"
              // target="_blank"
            >
              Uma aplicação desenvolvida por
            </p>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default LoginForm;
